<template>
  <div class="bg-white shadow">
    <button
      v-if="hasFiltersActive"
      @click="resetAllFilters"
      class="block w-full bg-blue-600 hover:bg-blue-700 text-white text-xs font-bold text-center p-2 mb-1"
    >
      Reiniciar filtros
    </button>
    <div
      v-else
      class="bg-gray-300 text-gray-700 text-xs font-bold text-center p-2"
    >
      Filtros
    </div>
    <div class="flex flex-wrap px-4">
      <label
        v-for="(filter, index) in currentTab.filters"
        :key="index"
        class="w-1/6 mb-2 pr-4"
      >
        <span
          class="font-semibold text-xs text-gray-600 hover:text-gray-800 cursor-pointer"
          >{{ filter.title }}</span
        >
        <FilterField :filter="filter" />
      </label>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from "vuex";

import FilterField from "@/components/FilterField";

export default {
  components: {
    FilterField,
  },
  computed: {
    ...mapState(["where"]),
    ...mapGetters(["currentTab"]),
    hasFiltersActive() {
      return Object.keys(this.where).length !== 0;
    },
  },
  methods: {
    ...mapActions(["requestEntries"]),
    ...mapMutations(["resetFilter"]),
    resetAllFilters() {
      this.resetFilter();
      this.requestEntries();
    },
  },
};
</script>
